module.exports = __webpack_public_path__ + "static/img/Isaac_Heeney_mobile.4b50094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaac_Heeney_mobile.jpg
// module id = DxxA
// module chunks = 0